import * as React from "react"

import { cn } from "@/lib/utils"
import { TypographyXSmall } from '@/components/ui/typography.jsx'

const Input = React.forwardRef(
    ({ className, containerClassName, type, error, ...props }, ref) => {
        return (
            <div className={containerClassName}>
                <input
                    type={type}
                    className={cn(
                        'text-foreground transition px-3 py-1 text-sm shadow-sm h-9 w-full rounded bg-neutral-100 font-light',
                        'file:border-0 file:bg-transparent file:text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
                        'border border-muted-foreground/50 focus:ring-0 focus:border focus:border-foreground/80',
                        className,
                        error && "border border-error-400 focus-visible:border-error-400"
                    )}
                    ref={ref}
                    {...props}
                />
                {error && <TypographyXSmall className="text-error-400 mt-2 pl-1">{error}</TypographyXSmall>}
            </div>
        )
    }
)
Input.displayName = "Input"

export { Input }
